export default {"src":"/_next/static/media/plus.7a00a72f.svg","height":26,"width":26,"blurWidth":0,"blurHeight":0};